<ng-container [formGroup]="metadataFormGroup">
  <div class="row row-cols-md-2 row-cols-1 mb-3">
    <div class="col">
      <label i18n>Actuellement, est...</label>
      <select class="form-control" formControlName="situation">
        <option *ngFor="let value of situationValues" [ngValue]="value">
          {{ getSituationLabel(value) }}
        </option>
      </select>
    </div>
    <div
      class="col"
      *ngIf="
        metadataFormGroup.value.situation !== ThirdPillarSituationEnum.OTHER
      "
    >
      <label i18n>Profession</label>
      <input class="form-control" formControlName="job" type="text" />
    </div>
    <div
      class="col"
      *ngIf="
        metadataFormGroup.value.situation === ThirdPillarSituationEnum.OTHER
      "
    >
      <label i18n>Description de la situation</label>
      <input
        class="form-control"
        formControlName="situationDescription"
        type="text"
      />
    </div>
  </div>
  <div class="row my-3">
    <div class="col">
      <label i18n>Épargne mensuelle idéale</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="idealMonthlySaving"
      />
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-1 my-3">
    <div class="col">
      <label i18n>Raison(s) d'épargne</label>
      <mat-form-field class="lty-input">
        <mat-select
          [formControl]="
            getControl(metadataFormGroup.controls['savingReasons'])
          "
          multiple
        >
          <mat-option
            *ngFor="let value of savingReasonValues"
            [value]="value"
            >{{ getSavingReasonLabel(value) }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col">
      <label i18n>Est plutôt</label>
      <select class="form-control" formControlName="ownDescription">
        <option *ngFor="let value of ownDescriptionValues" [ngValue]="value">
          {{ getOwnDescriptionLabel(value) }}
        </option>
      </select>
    </div>
  </div>
  <div class="row row-cols-1 my-3">
    <div class="col my-2">
      <label i18n>Possède déjà un 3ème pilier</label>
      <div class="form-check">
        <input
          type="radio"
          name="hasAlreadyThirdPillar"
          id="hasAlreadyThirdPillarFalse"
          [value]="false"
          formControlName="hasAlreadyThirdPillar"
        />
        <label class="form-check-label" for="hasAlreadyThirdPillarFalse">
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasAlreadyThirdPillar"
          id="hasAlreadyThirdPillarTrue"
          [value]="true"
          formControlName="hasAlreadyThirdPillar"
        />
        <label class="form-check-label" for="hasAlreadyThirdPillarTrue">
          Oui
        </label>
      </div>
    </div>
    <ng-container
      *ngIf="metadataFormGroup.value.hasAlreadyThirdPillar === true"
    >
      <div class="col my-2">
        <label i18n>Compagnie</label>
        <select
          class="form-control"
          formControlName="alreadyThirdPillarDescription"
        >
          <option *ngFor="let value of COMPANIES" [ngValue]="value">
            {{ getCentralisationInsurerLabel(value) }}
          </option>
        </select>
      </div>
      <div class="col my-2">
        <label i18n>Cotisation mensuelle</label>
        <input
          class="form-control"
          type="number"
          formControlName="alreadyThirdPillarValue"
        />
      </div>
    </ng-container>
  </div>
</ng-container>
